import { lazy } from "react";

export const paymentStatusRoute = {
  path: "/reservation-status",
  exact: true,
  component: lazy(() => import("./index")),
};
export const RESERVATION_UUID_QUERY_PARAM_NAME = "uuid";
export const RESERVATION_REF_QUERY_PARAM_NAME = "ref";
